import React, { Component } from "react";
// import GoogleLogin from 'react-google-login';
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import loginNavenderLogo from "./bgwithlogo.svg";
import config from "../../../src/globs/config";
import gaPush from "../../globs/utils/google-analytics";
import environmentVariables from "../../../src/globs/utils/get-environment-variables";

class Login extends Component {
  state = {
    unauthorized: false,
    showNotificationPopup: false,
    showNotificationDeniedAlert: false,
  };

  componentDidUpdate(prevProps, prevState) {
    console.log("prevProps", prevProps, this.props);
    const { props } = this;

    // CRITICAL FIX: Only call nextPageAccess when token actually changes
    // Prevents infinite redirect loop in React 19
    // Previously this was called on EVERY update, causing continuous redirects
    if (prevProps.user._token !== props.user._token && props.user._token) {
      this.nextPageAccess(props);
    }

    if (
      prevProps.ajaxStatuses.login === "PENDING" &&
      props.ajaxStatuses.login === ""
    ) {
      console.log("props.user.unauthorized", props.user.unauthorized);
      if (props.user.errorMessage === "unauthorized") {
        // this.setState({
        //   unauthorized: true,
        // }, () => {
        //   setTimeout(() => {
        //     this.setState({
        //       unauthorized: false,
        //     })
        //   }, 5000);
        // });
      }
    }
  }

  nextPageAccess = (props) => {
    if (props.user._token && !this.state.showNotificationPopup) {
      const salesOfficerId = props.user.id;
      const url = `${config.apiContextPath}/sales_officers/${salesOfficerId}`;
      props.dataLoad({ key: "userLaod", url });

      // Check if notification permission has already been granted or denied
      const notificationPermission = Notification.permission;

      if (notificationPermission === 'default') {
        // Permission not yet requested, show custom UI prompt
        this.setState({ showNotificationPopup: true });
      } else if (notificationPermission === 'granted') {
        // Permission already granted, subscribe silently and navigate
        props.subscribeWithExistingPermission(props.user);
        props.history.push("/home-page");
      } else {
        // Permission denied, just navigate without subscribing
        props.history.push("/home-page");
      }
    }
  };

  handleNotificationAccept = async () => {
    this.setState({ showNotificationPopup: false });

    try {
      // Request notification permission
      const permission = await Notification.requestPermission();

      if (permission === "granted") {
        // Permission granted, subscribe to notifications
        this.props.subscribeNotifications(this.props.user);
        this.props.history.push("/home-page");
      } else if (permission === "denied") {
        // Permission denied, show alert modal
        this.setState({ showNotificationDeniedAlert: true });
      } else {
        // Permission dismissed (default), just navigate
        this.props.history.push("/home-page");
      }
    } catch (error) {
      console.error("Error requesting notification permission:", error);
      this.props.history.push("/home-page");
    }
  };

  handleDeniedAlertClose = () => {
    this.setState({ showNotificationDeniedAlert: false }, () => {
      this.props.history.push("/home-page");
    });
  };

  handleNotificationDismiss = () => {
    this.setState({ showNotificationPopup: false }, () => {
      this.props.history.push("/home-page");
    });
  };

  responseGoogle = (res) => {
    console.log("res", res);
    const url = `${config.apiContextPath}/login`;
    const { props } = this;
    props.login({
      // email: res.profileObj.email,
      // google_user_id: res.profileObj.googleId,
      // username: res.profileObj.name,
      targetUrl: url,
      // tokenId: res.tokenId,
      clientId: res.clientId,
      credential: res.credential,
      select_by: res.select_by,
    });
  };
  fireGaEventPagePath = (path) => {
    gaPush("pageview", {
      path,
    });
  };

  fireGaEvent = (act, action) => {
    gaPush("event", {
      category: act,
      action,
    });
  };

  render() {
    return (
      <div className="google-login-page">
        <img src={loginNavenderLogo} alt="logo" />
        <h3>Sales Officer</h3>
        <div className="google-login-button">
          {/* <GoogleLogin
                      clientId= {environmentVariables.REACT_APP_GOOGLE_CLIENT_ID}
                      buttonText="Sign in with Google"
                      onSuccess={this.responseGoogle}
                      onFailure={this.responseGoogle}
                    cookiePolicy={'single_host_origin'}
                    /> */}
          <GoogleOAuthProvider
            clientId={environmentVariables.REACT_APP_GOOGLE_CLIENT_ID}
          >
            <GoogleLogin
              onSuccess={this.responseGoogle}
              onError={this.responseGoogle}
            />
          </GoogleOAuthProvider>
        </div>
        {this.state.showNotificationPopup && (
          <div className="notification-overlay">
            <div className="notification-modal">
              <h2>Allow Notifications?</h2>
              <p>We'd like to send you push notifications for updates.</p>
              <div className="button-group">
                <button onClick={this.handleNotificationAccept}>Allow</button>
                <button onClick={this.handleNotificationDismiss}>
                  Not Now
                </button>
              </div>
            </div>
          </div>
        )}

        {this.state.showNotificationDeniedAlert && (
          <div className="notification-overlay">
            <div className="notification-modal notification-denied-modal">
              <h2>⚠️ Notifications Blocked</h2>
              <p>
                You've denied notification permissions. To receive important updates, you'll need to enable notifications through your browser settings.
              </p>
              <div className="instructions">
                <p><strong>How to enable:</strong></p>
                <ol>
                  <li>Click the lock icon or site settings in your browser's address bar</li>
                  <li>Find "Notifications" in the permissions list</li>
                  <li>Change the setting from "Block" to "Allow"</li>
                  <li>Reload the page and log in again</li>
                </ol>
              </div>
              <div className="button-group">
                <button onClick={this.handleDeniedAlertClose} className="single-button">
                  Got it
                </button>
              </div>
            </div>
          </div>
        )}

        {/* <p className="na-url-msg">The Sales Officer app has a new home!</p>
          <p className="na-url-msg">We've moved to a new link : <a href="https://navendor-so.clickitapp.io/" target="_blank">https://navendor-so.clickitapp.io/</a> Please bookmark the new link.</p>
          <a className="na-url-link" href="https://navendor-so.clickitapp.io/" target="_blank" rel="noreferrer">
            <button className="na-url-btn">Go there now!</button>
          </a> */}
        {this.state.unauthorized &&
          this.props.user.errorMessage &&
          this.props.user.errorMessage === "unauthorized" && (
            <div className="unauthorized-msg">
              <p>{`Unauthorized User`}</p>
            </div>
          )}
        <style>
          {`
            .notification-overlay {
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.5);
              display: flex;
              justify-content: center;
              align-items: center;
              z-index: 1000;
            }

            .notification-modal {
              background: white;
              padding: 24px 32px;
              border-radius: 12px;
              max-width: 400px;
              width: 90%;
              text-align: center;
              box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
            }

            .notification-modal h2 {
              margin-top: 0;
              font-size: 20px;
            }

            .notification-modal p {
              font-size: 16px;
              margin: 12px 0;
            }

            .button-group {
              display: flex;
              justify-content: space-between;
              margin-top: 20px;
            }

            .button-group button {
              padding: 10px 20px;
              border: none;
              border-radius: 6px;
              cursor: pointer;
            }

            .button-group button:first-child {
              background-color: #4caf50;
              color: white;
            }

            .button-group button:last-child {
              background-color: #ccc;
              color: black;
            }

            .notification-denied-modal {
              max-width: 500px;
            }

            .notification-denied-modal h2 {
              color: #f44336;
              font-size: 22px;
            }

            .notification-denied-modal .instructions {
              background-color: #f5f5f5;
              padding: 16px;
              border-radius: 8px;
              margin: 16px 0;
              text-align: left;
            }

            .notification-denied-modal .instructions p {
              margin: 0 0 8px 0;
              font-weight: 600;
            }

            .notification-denied-modal ol {
              margin: 8px 0;
              padding-left: 20px;
            }

            .notification-denied-modal ol li {
              margin: 8px 0;
              font-size: 14px;
              line-height: 1.5;
            }

            .single-button {
              width: 100%;
              background-color: #2196f3 !important;
              color: white !important;
              padding: 12px 24px;
              font-size: 16px;
              font-weight: 600;
            }
          `}
        </style>
      </div>
    );
  }
}

export default Login;
